import { SKILLS, EXPERIENCE, EDUCATION, CERTS, BENEFITS } from "@/data/portfolio";
import Benefit from "@/components/site/Benefit";
import { T, useLang } from "@/lib/i18n";


export default function Experience() {
  const { t } = useLang();
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="border-t border-[#e5e0d8] section-pad bg-[#faf8f5]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">
        <div className="max-w-2xl">
          <div className="font-mono-label text-[11px] text-[#9a7218]">
            {t("02 · My experience")}
          </div>
        </div>

        <div className="mt-8 grid lg:grid-cols-12 gap-6 items-start">
          {/* Experience timeline */}
          <div className="lg:col-span-7 bg-[#14352a] text-[#faf8f5] p-6 sm:p-7">
            <ol className="space-y-5">
              {EXPERIENCE.map((e, i) => (
                <li
                  key={i}
                  data-testid={`experience-item-${i}`}
                  className="grid sm:grid-cols-12 gap-2 sm:gap-5 border-b border-[#2e333c] pb-5 last:border-0 last:pb-0"
                >
                  <div className="sm:col-span-3 font-mono-label text-[9px] text-[#86928a] pt-1">
                    {t(e.period)}
                  </div>
                  <div className="sm:col-span-9">
                    <div className="font-display text-lg leading-tight">
                      {t(e.role)}{" "}
                      <span className="text-[#d9a92e] text-sm font-sans">
                        · {e.org}
                      </span>
                      {e.note && (
                        <span data-testid="experience-note-0" className="ml-2 sticker font-mono-label text-[8px] rotate-0 align-middle">
                          {t(e.note)}
                        </span>
                      )}
                    </div>
                    <p className="mt-1.5 text-sm text-[#faf8f5]/70 leading-relaxed">
                      {t(e.body)}
                    </p>
                    {e.focus && (
                      <p data-testid={`experience-focus-${i}`} className="mt-1.5 text-[13px] text-[#d9a92e] leading-relaxed">
                        {t(e.focus)}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-6 pt-5 border-t border-[#2e333c] grid sm:grid-cols-2 gap-5">
              <div>
                <div className="font-mono-label text-[9px] text-[#9a7218]">
                  Education
                </div>
                <ul className="mt-2 space-y-1.5">
                  {EDUCATION.map((e, i) => (
                    <li key={i} className="text-sm">
                      <span className="text-[#faf8f5]">{t(e.title)}</span>
                      <span className="text-[#faf8f5]/50"> · {e.org}</span>
                      {e.note && (
                        <span className="ml-2 sticker font-mono-label text-[8px] rotate-0">
                          {t(e.note)}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <div className="font-mono-label text-[9px] text-[#9a7218]">
                  {t("Certifications")}
                </div>
                <ul className="mt-2 space-y-1.5 text-sm text-[#faf8f5]/80">
                  {CERTS.map((c, i) => (
                    <li key={i} className="flex gap-2">
                      <span className="text-[#d9a92e]">◆</span>
                      {t(c)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Skills */}
          <div id="skills" data-testid="skills-section" className="lg:col-span-5 space-y-3">
            {SKILLS.map((s, i) => (
              <div
                key={i}
                data-testid={`skill-group-${i}`}
                className="p-4 bg-white border border-[#e5e0d8]"
              >
                <div className="flex items-baseline gap-2">
                  <span className="font-mono-label text-[9px] text-[#9a7218]">
                    0{i + 1}
                  </span>
                  <h3 className="font-display text-base text-[#14352a]">
                    {t(s.group)}
                  </h3>
                </div>
                <ul className="mt-2.5 flex flex-wrap gap-1.5">
                  {s.items.map((it) => (
                    <li
                      key={it}
                      className="text-[11px] px-2.5 py-1 border border-[#e5e0d8] text-[#55625b] bg-[#faf8f5] rounded-full hover:border-[#9a7218] hover:text-[#9a7218] transition-colors"
                    >
                      {t(it)}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <Benefit text={BENEFITS.experience} testid="benefit-experience" />
      </div>
    </section>
  );
}
